// extracted by mini-css-extract-plugin
module.exports =  {"dashboardTabs":"dashboardTabs__oil9Z"};